import React from "react";
import { Card, Button, Row, Col, Accordion } from "react-bootstrap";
import { ActionHandlerFunction, AdminApprovalGroup, AdminUserBase } from "@preveil-api";
import { AdminMessages, AdminUIActionTypes, DataExportAllContent, dropdown_labels, FilterStates, Message, MessageAnchors, MessageHandlerDisplayType, MessageToastTypes, useAppDispatch } from "src/common";
import { DateFilter } from "src/components/shared/filters";
import { ExportContentCollapse, UsersCollapse } from ".";
import { uiActions } from "src/store";

type AllProps = {
    users_label: string;
    date_range_label: string;
    content: DataExportAllContent;
    org_users: AdminUserBase[];
    approval_group: AdminApprovalGroup;
    handleAction: ActionHandlerFunction;
    is_get_started_disabled: boolean;
    refetchUsersShardStatuses: () => void;
    is_loading: boolean;
};

// Description: This component is used to render the Get Started card in the data export get started page
function GetStartedComponent(props: AllProps) {
    const { content, org_users, users_label, date_range_label, approval_group, handleAction, is_get_started_disabled, refetchUsersShardStatuses, is_loading } = props;
    const dispatch = useAppDispatch();
    const content_label = Object.keys(content)
        .filter((key) => key !== "include_all_versions" && (content as any)[key])
        .map((key) => (dropdown_labels.content as any)[key])
        .join(" & ");
    

    // Description: Confirm starting the data export process
    function confirmGetStartedDataExport() {
        const confirmation_dialog = new Message(
            AdminMessages.confirm_get_started_data_export.body.replace(MessageAnchors.message_content, approval_group?.name || ""),
            MessageHandlerDisplayType.confirm,
            MessageToastTypes.primary,
            AdminMessages.confirm_get_started_data_export.title,
            {
                label: "Yes",
                data: true,
                action: () => handleAction({ actionType: AdminUIActionTypes.RequestDataExport })
            }
        );
        dispatch(uiActions.handleSetMessage(confirmation_dialog));
    }

    return <Card className="pv-card data-export-card">
        <Card.Header className="pb-0">Download a decrypted copy of your organization's data.</Card.Header>
        <Card.Body>
            <div className="export-profile">
                <Row>
                    <Col md={4}>Approval Group</Col>
                    <Col>{approval_group.name || ""}</Col>
                </Row>
                <Row>
                    <Col md={4}>Required Approvers</Col>
                    <Col>{approval_group.required_approvers || ""}</Col>
                </Row>
            </div>
            <Card.Text>
                To begin your data export, click <b>"Get Started"</b> below. Be sure to review the scope of the export below.
            </Card.Text>
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>{`Users: ${users_label}`}</Accordion.Header>
                    <Accordion.Body>
                    <UsersCollapse org_users={org_users} refetchUsersShardStatuses={refetchUsersShardStatuses} is_loading={is_loading} />
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>{`Content: ${content_label}`}</Accordion.Header>
                    <Accordion.Body className="pt-0 pb-0">
                    <ExportContentCollapse handleAction={handleAction} content={content}/>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>{`Date Range: ${date_range_label}`}</Accordion.Header>
                    <Accordion.Body className="list-filters p-3">
                    <DateFilter
                        default_value={null}
                        default_active={FilterStates.last_two_weeks}
                        handleAction={handleAction} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Button
                className="mt-3"
                variant="primary"
                disabled={is_get_started_disabled || !content_label}
                onClick={confirmGetStartedDataExport}
            >
                Get Started
            </Button>
        </Card.Body>
    </Card>;
}

export default React.memo(GetStartedComponent);